<template>
  <v-card :id="uniqueId" class="module-card">
    <v-img :src="imageURL(model.uid)" height="240px" class="white--text align-end orangebg">
      <v-card-title :id="uniqueId + '-title'" class="clear pt-6 white--text bold shadowed wrapped">
        <v-row :id="uniqueId + '-row'" class="pl-3" :class="{ faded: !available }">
          {{ title() }}
        </v-row>
      </v-card-title>
    </v-img>
    <v-card-text :id="uniqueId + '-card-text'" style="display: flex; justify-content: center; align-items: center;">
      <v-chip :id="uniqueId + '-status-chip'" class="status-chip" style="padding: 0; margin-right: 10px">
        <div :id="uniqueId + '-status-div'" style="height:100%; width: 220px;">
          <template v-if="loading">
            <div :id="uniqueId + '-loading-div'" style="display: flex; justify-content: center;">
              <v-progress-circular 
                indeterminate
                color="green"
                size="30"
                width="5"
              />
            </div>
          </template>
          <template v-else>
            <v-progress-linear 
              :value="progress" 
              :aria-labelledby="uniqueId + '-status-text'"
              height="100%"
              color="green"
              class="status-progress-bar"
              style="background-color: lightgreen; border-radius: 15px; "
            />
            <div :id="uniqueId + '-status-text'" class="status-text centered" style="color:black; font-size:small">
              {{ $t('module-card.progress', [progress]) }}
            </div>
          </template>
        </div>
      </v-chip>
      <v-menu :id="uniqueId + '-menu'" offset-y :attach="`#${uniqueId}-actions-button`">  
        <template v-slot:activator="{ on, attrs }">
            <v-btn 
              :id="uniqueId + '-actions-button'"
              color="secondary" 
              v-bind="attrs" 
              style="height: 32px" 
              :aria-describedby="uniqueId + '-row'"
              v-on="on"
            >
                {{ $t('module-card.actions') }}
            </v-btn>
        </template>
        <v-list :id="uniqueId + '-list'">
          <v-list-item v-for="(action, index) in actions" :key="index">  
              <v-btn 
                :id="uniqueId + '-action-' + index"
                :aria-label="action.title"
                tabindex="0"
                text 
                block 
                :disabled="action.disabled" 
                @click="action.action"
              > 
                {{ action.title }}
              </v-btn>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-card-text>
  
    <v-card-text :id="uniqueId + '-promo-text'">
      {{ promoText() }}
    </v-card-text>
  </v-card>
</template>

<script>
  import moment from 'moment'

  export default {
    name: 'ModuleCard',

    props: {
      model: {
        type: Object,
        required: true,
        default: undefined,
      },
      available: {
        type: Boolean,
        required: false,
        default: false,
      },
    },

    data () {
      return {
        show: false,
        loading: false,
        uniqueId: 'module-card-' + Math.random().toString(36).substr(2, 9),
      }
    },

    computed: {
      actions: function () {
        let index = 0
        const options = []

        // Only show PLAY button if account is not suspended
        const currentAccount = this.$store.getters.currentUserProfile?.account
        const expires = moment(currentAccount.expires).toDate()
        const isSuspended = !currentAccount.active || expires < new Date()
        options.push({
          index: index++,
          title: this.$t('content.launch'),
          action: () => this.launch(this.model),
          disabled: isSuspended,
        })
        

        if (this.model.learnerReports && this.model.uid === 'IPE') {
          if (this.sessions && this.sessions.length > 0) {
            for (const session of this.sessions) {
              const sessionDate = moment(session.updated).format('DD-MM-YYYY')
              options.push({ index: index++, title: this.$t('module-card.view-report', [sessionDate]), action: () => this.gotoReport(session) })
            }
          }
        } else {
          if (this.journalLink) options.push({ index: index++, title: this.$t('certficateDisplay.download-learning-journal'), action: () => this.gotoExternal(this.journalLink), disabled: false })
          options.push({ index: index++, title: this.$t('certficateDisplay.get-certificate'), action: () => this.gotoExternal(this.certificateLink()), disabled: !this.model.certificate })
        }

        return options
      },
      progress: function () {
        // console.log(this.model.uid, 'progress model.progress', this.model.progress)
        return this.model.progress || 0
      },
      journalLink: function () {
        if (!this.model) {
          return undefined
        }
        if (this.model.journalLinks && this.model.journalLinks[this.$i18n.locale]) {
          return this.model.journalLinks[this.$i18n.locale]
        }
        return this.model.journalLink
      },
    },

    methods: {
      gotoExternal (url) {
        window.location.href = url
      },
      gotoInternal (url) {
        this.$router.push(url)
      },
      gotoReport (report) {
        // check if this report.path is a URL http or https or a sessionId
        if (report.path.startsWith('http') || report.path.startsWith('https')) {
          window.open(report.path, '_blank')
        } else {
          this.$router.push({
            name: 'Learner Report',
            params: {
              sessionId: report.path,
              title: 'Learner Report',
            },
          })
        }
      },
      promoText () {
        return this.model.locales?.[this.$i18n.locale]?.promoText ?? this.model.locales?.en?.promoText ?? this.model.promoText
      },
      title () {
        return this.model.locales?.[this.$i18n.locale]?.title ?? this.model.locales?.en?.title ?? this.model.title
      },
      launch (item) {
        this.$router.push('/admin/launch?module=' + item.uid)
      },
      imageURL (id) {
        return `https://storage.googleapis.com/bodyswaps-public/img/${id}.jpg`
      },
      certificateLink () {
        if (this.model.certificate)
        {
          return '#/certificate/' + this.model.certificate
        }
        else
        {
          return 'none'
        }
      },
    },
  }
</script>

<style scoped>
.menudropdown {
  margin-top: 0px;
  margin-bottom: 0px;
}

.orangebg {
  background-color: #eb6305
}

.button {
  cursor: pointer;
  color: rgb(199, 199, 199);
}

.clear {
  background: none;
  color: black;
}

.top-right {
  position: absolute;
  top: 5px;
  right: 5px;
  color: rgb(145, 145, 145)
}

.bold {
  font-weight: 600;
}

.faded {
  opacity: 0.7
}

.unavailable {
  color: red !important;
}

.wrapped {
  white-space: normal;
  word-break: break-word !important;
  line-height: 1.2em;
}

.completed {
  background-color: #ff9416;
  color: white;
  text-align: center;
  position: absolute;
  top: 0;
  width: 100%;
  height: 35px;
  line-height: 35px;
}

.shadowed {
  text-shadow: 2px 2px 8px #000000;
}

.coverimage {
  height: 240px;
}

.centered {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.v-menu__content {
  position: absolute;
  top: 40px !important; /* Adjust as needed */
  left: 0 !important; /* Adjust as needed */
  max-width: fit-content;
}

.module-card {
  background-color: #eff1f8;
  padding: 0px;
  padding-bottom: 10px;
}
</style>
